const elementWithKFrequency = (arr, k) => {
  //Store the number counts in object
  const count = arr.reduce((a, b) => {
    if (!a[b]) {
      a[b] = 1;
    } else {
      a[b]++;
    }

    return a;
  }, {});

  //Find the number with k count
  for (const [key, value] of Object.entries(count)) {
    if (value === k) {
      return key;
    }
  }

  return -1;
};

export default elementWithKFrequency;
